<template>
    <div class="modal fade show add-note-modal" aria-labelledby="addNoteAttachmentTitle">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center px-1 my-1">
                            <h1 class="mb-0 note-title">{{ 'Attachments - ' + note.name }}</h1>
                            <button @click="closeModal" type="button" class="btn-close" aria-label="Close"></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0">

                <div class="modal-body">
                    <div class="row gy-2 px-2">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body">
                                    <BlobFileViewer :attachments="note.attachments" />
                                    <FileUpload
                                        :is-drag-active="true"
                                        button-text="Upload Documents"
                                        v-model="note.attachments"
                                    />
                                    <div class="text-center mt-1">
                                        <button type="button" @click="onSaveAttachments" :disabled="loading" class="btn btn-primary waves-effect waves-float waves-light">
                                            <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                            Save Documents
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Loader v-if="loading"/>
    </div>
</template>

<script setup>
import { inject, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import Loader from '@/components/atom/LoaderComponent'
import FileUpload from '@/components/atom/FileUpload';
import BlobFileViewer from '@/components/atom/BlobFileViewer';
import handleDentalOs from '@/services/modules/dental-os/dentalOs';

const { updateNoteAttachments } = handleDentalOs();

const showError = inject('showError');
const showSuccess = inject('showSuccess');

const $route = useRoute();

const props = defineProps({
    note: Object
})

const emit = defineEmits(['close']);

const loading = ref(false);

const closeModal = () => {
    emit('close');
}

const onSaveAttachments = async () => {
    const data = formatAttachmentFormData();

    loading.value = true;
    await updateNoteAttachments(props.note.id, data).then((res) => {
        if (!res.status) return showError(res.message);
        props.note.attachments = res.data ? res.data : [];
        return showSuccess(res.message);
    }).catch((err) => {
        console.log(err);
    }).finally(() => {
        loading.value = false;
    })
}

const formatAttachmentFormData = () => {
    const previousFileIds = [];
    const data = new FormData();
    data.append('company_id', $route.params.companyId);

    props.note.attachments.forEach((file) => {
        if (typeof file === 'object' && file.hasOwnProperty('id')) {
            previousFileIds.push(file.id);
            return;
        }
        data.append('attachments[]', file);
    });

    data.append('previous_file_ids', JSON.stringify(previousFileIds));
    return data;
}

onMounted(() => {
    if (!Array.isArray(props.note.attachments)) {
        props.note.attachments = [];
    }
})
</script>

<style scoped>
.note-title {
    width: 60%;
}
.modal-body {
    min-height: 250px;
}
.add-note-modal {
    display: block;
    background: #1c1d1c33;
}
</style>
